export const environment = {
  production: false,
  baseUrl: '',
  kdsUrl: 'https://dev.kds.tapgo.ch',
  tenantMgmtAPI: 'https://tenant.dev.tapgo.ch/app/v1',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
  },
  smashedUrl: 'https://smashed.ch',
  smashedDomain: '9lcs9h',

  STRIPE_PUBLIC_KEY: '',
  customerUrl: 'https://menu.dev.tapgo.ch',
  adminPanelUrl: 'https://dev.admin.tapgo.ch',

  //preprod
  // api: 'https://main-api.preprod-tastio.com/app/v1',
  // tenantApi: 'https://tenant-api.preprod-tastio.com/app/v1',

  qrAppUrl: 'https://qr.tapgo.ch',
  registerUrl: 'https://dev.admin.tapgo.ch/',

  //Development
  // api: 'http://localhost:8080/app/v1',
  api: 'https://main.dev.tapgo.ch/app/v1',
  tenantApi: 'https://tenant.dev.tapgo.ch/app/v1',
  // registerUrl: 'https://preprod-tastio.web.app/',
  // qrAppUrl: 'https://qrapp.preprod-tastio.com'

  //S3 Bucket Ids
  SPACE_NAME: 'demo-tap-go',
  S3_URL: 'https://demo-tap-go.sos-ch-dk-2.exoscale-cdn.com/',
  END_POINTS: 'https://sos-ch-dk-2.exo.io',
  accessKeyId: 'EXO7271da746d6be79546a27dcd',
  secretAccessKey: 'jhbuil94UeLvpdfnHOM_V84uikAyLw-phqNTQiDogpA',
};
